// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperadminSetting_container__6yXGu {
    padding: 2rem;
    min-height: 100vh;
    background-color: #1F1D1D;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .SuperadminSetting_header__dzmgv {
    text-align: center;
    margin-bottom: 4rem;
    width: 100%;
  }
  
  .SuperadminSetting_title__PArh8 {
    font-size: 2.5rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.5rem;
  }
  
  .SuperadminSetting_subtitle__Ava2- {
    color: #808080;
    font-size: 1.1rem;
  }
  
  .SuperadminSetting_blocksContainer__yWrK5 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    width: 100%;
    max-width: 1200px;
  }
  
  .SuperadminSetting_block__st0xp {
    background-color: #000000;
    border-radius: 1rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
  }
  
  .SuperadminSetting_block__st0xp::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(229, 0, 0, 0.2) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .SuperadminSetting_block__st0xp:hover {
    transform: translateY(-5px);
    border-color: rgba(229, 0, 0, 0.3);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }
  
  .SuperadminSetting_block__st0xp:hover::before {
    opacity: 1;
  }
  
  .SuperadminSetting_iconWrapper__1pAJS {
    background-color: rgba(229, 0, 0, 0.1);
    padding: 1.5rem;
    border-radius: 1rem;
    margin-bottom: 1.5rem;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;
  }
  
  .SuperadminSetting_block__st0xp:hover .SuperadminSetting_iconWrapper__1pAJS {
    transform: scale(1.1);
    background-color: rgba(229, 0, 0, 0.15);
  }
  
  .SuperadminSetting_blockIcon__zJzYJ {
    width: 2rem;
    height: 2rem;
    color: #E50000;
  }
  
  .SuperadminSetting_blockTitle__rXAzZ {
    font-size: 1.25rem;
    color: #ffffff;
    margin: 0;
    position: relative;
    z-index: 1;
    transition: transform 0.3s ease;
  }
  
  .SuperadminSetting_block__st0xp:hover .SuperadminSetting_blockTitle__rXAzZ {
    transform: scale(1.05);
  }
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .SuperadminSetting_blocksContainer__yWrK5 {
      grid-template-columns: repeat(2, 1fr);
      max-width: 800px;
    }
  }
  
  @media (max-width: 768px) {
    .SuperadminSetting_container__6yXGu {
      padding: 1.5rem;
    }
    
    .SuperadminSetting_title__PArh8 {
      font-size: 2rem;
    }
    
    .SuperadminSetting_blocksContainer__yWrK5 {
      grid-template-columns: 1fr;
      max-width: 400px;
    }
    
    .SuperadminSetting_block__st0xp {
      padding: 1.5rem;
    }
  }
  
  @media (max-width: 480px) {
    .SuperadminSetting_container__6yXGu {
      padding: 1rem;
    }
    
    .SuperadminSetting_title__PArh8 {
      font-size: 1.75rem;
    }
    
    .SuperadminSetting_subtitle__Ava2- {
      font-size: 1rem;
    }
    
    .SuperadminSetting_block__st0xp {
      padding: 1.25rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/SuperadminSetting.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uFAAuF;IACvF,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE;MACE,qCAAqC;MACrC,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;EACF","sourcesContent":[".container {\n    padding: 2rem;\n    min-height: 100vh;\n    background-color: #1F1D1D;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .header {\n    text-align: center;\n    margin-bottom: 4rem;\n    width: 100%;\n  }\n  \n  .title {\n    font-size: 2.5rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin-bottom: 0.5rem;\n  }\n  \n  .subtitle {\n    color: #808080;\n    font-size: 1.1rem;\n  }\n  \n  .blocksContainer {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    width: 100%;\n    max-width: 1200px;\n  }\n  \n  .block {\n    background-color: #000000;\n    border-radius: 1rem;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .block::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: radial-gradient(circle at center, rgba(229, 0, 0, 0.2) 0%, transparent 70%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  \n  .block:hover {\n    transform: translateY(-5px);\n    border-color: rgba(229, 0, 0, 0.3);\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  }\n  \n  .block:hover::before {\n    opacity: 1;\n  }\n  \n  .iconWrapper {\n    background-color: rgba(229, 0, 0, 0.1);\n    padding: 1.5rem;\n    border-radius: 1rem;\n    margin-bottom: 1.5rem;\n    position: relative;\n    z-index: 1;\n    transition: all 0.3s ease;\n  }\n  \n  .block:hover .iconWrapper {\n    transform: scale(1.1);\n    background-color: rgba(229, 0, 0, 0.15);\n  }\n  \n  .blockIcon {\n    width: 2rem;\n    height: 2rem;\n    color: #E50000;\n  }\n  \n  .blockTitle {\n    font-size: 1.25rem;\n    color: #ffffff;\n    margin: 0;\n    position: relative;\n    z-index: 1;\n    transition: transform 0.3s ease;\n  }\n  \n  .block:hover .blockTitle {\n    transform: scale(1.05);\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 1024px) {\n    .blocksContainer {\n      grid-template-columns: repeat(2, 1fr);\n      max-width: 800px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 1.5rem;\n    }\n    \n    .title {\n      font-size: 2rem;\n    }\n    \n    .blocksContainer {\n      grid-template-columns: 1fr;\n      max-width: 400px;\n    }\n    \n    .block {\n      padding: 1.5rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .container {\n      padding: 1rem;\n    }\n    \n    .title {\n      font-size: 1.75rem;\n    }\n    \n    .subtitle {\n      font-size: 1rem;\n    }\n    \n    .block {\n      padding: 1.25rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SuperadminSetting_container__6yXGu`,
	"header": `SuperadminSetting_header__dzmgv`,
	"title": `SuperadminSetting_title__PArh8`,
	"subtitle": `SuperadminSetting_subtitle__Ava2-`,
	"blocksContainer": `SuperadminSetting_blocksContainer__yWrK5`,
	"block": `SuperadminSetting_block__st0xp`,
	"iconWrapper": `SuperadminSetting_iconWrapper__1pAJS`,
	"blockIcon": `SuperadminSetting_blockIcon__zJzYJ`,
	"blockTitle": `SuperadminSetting_blockTitle__rXAzZ`
};
export default ___CSS_LOADER_EXPORT___;
